<template>
  <div>
    <label class="hey" :for="inputName">{{inputLabel}}</label>
    <datepicker
      @selected="selectDate"
      :name="inputName"
      :input-class="inputComputedClassName"
      :value="inputValue"
    ></datepicker>
    <span v-if="!isValid">{{errorText}}</span>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Datepicker
  },
  props: {
    inputName: String,
    inputLabel: String,
    inputValue: Date,
    setInput: Function,
    isValid: Boolean,
    disabled: Boolean,
    errorText: String
  },
  computed: {
    inputComputedClassName: function() {
      return this.isValid
        ? "datepicker-input"
        : "datepicker-input datepicker-error";
    },
    spanClassName: function() {
      return this.isValid ? "hide" : "show";
    }
  },
  methods: {
    selectDate: function(date) {
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      const formattedDate = day + "-" + month + "-" + year;
      this.setInput(formattedDate, date);
    }
  }
};
</script>

<style lang="scss" scoped>
label {
  display: block;
  margin-bottom: 4px;
  font-size: 16px;
  font-weight: 700;
}

span {
  display: block;
  margin: 4px 2px;
  color: #bd1f23;
}

.hide {
  display: none;
}

.show {
  display: block;
}
</style>

